import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  categoryName: string;
  status: string;
  rating: number;
  views: number;
  chapters: number;
  description?: string;
  variant?: 'grid' | 'list';
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  categoryName,
  status,
  rating,
  views,
  chapters,
  description,
  variant = 'grid',
}: ComicCardProps) {
  const formatViews = (v: number): string => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  if (variant === 'list') {
    return (
      <Link
        to={`/chapter/${id}/186`}
        className="flex gap-5 p-4 bg-background-100 rounded-lg hover:bg-background-200/70 transition-all duration-300 group cursor-pointer"
      >
        <div className="w-[120px] h-[160px] flex-shrink-0 rounded-md overflow-hidden">
          <img src={cover} alt={title} className="w-full h-full object-cover" loading="lazy" />
        </div>
        <div className="flex flex-col justify-between flex-1 min-w-0">
          <div>
            <div className="flex items-center gap-2 mb-1 flex-wrap">
              <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">{title}</h3>
              <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap ${status === '连载中' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'}`}>
                {status}
              </span>
            </div>
            <p className="text-sm text-foreground-500 mb-2">{author} · {categoryName}</p>
            {description && (
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">{description}</p>
            )}
          </div>
          <div className="flex items-center gap-4 text-xs text-foreground-500 mt-3 flex-wrap">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-star-fill text-amber-400"></i> {rating}
            </span>
            <span className="whitespace-nowrap">{formatViews(views)} 阅读</span>
            <span className="whitespace-nowrap">共{chapters}话</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/chapter/${id}/186`}
      className="group cursor-pointer"
    >
      <div className="relative rounded-lg overflow-hidden mb-3 aspect-[3/4] bg-background-200">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 left-2">
          <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${status === '连载中' ? 'bg-accent-500 text-white' : 'bg-secondary-500 text-white'}`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 bg-black/50 backdrop-blur-sm text-white text-xs px-2 py-0.5 rounded-full flex items-center gap-1 whitespace-nowrap">
          <i className="ri-star-fill text-amber-400 text-[10px]"></i> {rating}
        </div>
      </div>
      <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 truncate">{title}</h3>
      <p className="text-xs text-foreground-500 mt-1">{author} · {categoryName}</p>
    </Link>
  );
}